import { Outlet } from 'react-router-dom';

// Decorative flourish SVG
const Flourish = (_props: { 'aria-hidden'?: 'true' | boolean }) => (
  <svg className="w-32 h-8 text-terracotta-300" viewBox="0 0 120 24" fill="none" aria-hidden="true">
    <path
      d="M0 12h40c8 0 12-6 20-6s12 6 20 6h40"
      stroke="currentColor"
      strokeWidth="0.75"
    />
    <circle cx="60" cy="12" r="2.5" fill="currentColor" />
    <circle cx="45" cy="12" r="1.5" fill="currentColor" opacity="0.5" />
    <circle cx="75" cy="12" r="1.5" fill="currentColor" opacity="0.5" />
  </svg>
);

export function AuthLayout() {
  return (
    <div className="min-h-screen flex relative overflow-hidden">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-white focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:text-foreground focus:outline-none">Salt la conținut</a>
      {/* Left side - Decorative Panel */}
      <div className="hidden lg:flex lg:w-1/2 relative bg-gradient-to-br from-terracotta-50 via-lavender-50/50 to-sage-50/30">
        {/* Decorative orbs - matching marketing site style */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-1/4 -left-1/4 w-[60%] h-[80%] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, hsl(16 50% 85% / 0.3) 0%, transparent 70%)' }} />
          <div className="absolute -bottom-1/4 -right-1/4 w-[50%] h-[70%] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, hsl(262 40% 88% / 0.2) 0%, transparent 70%)' }} />
          <div className="absolute top-1/3 right-1/4 w-[30%] h-[40%] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, hsl(143 25% 85% / 0.15) 0%, transparent 70%)' }} />
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center w-full px-12">
          <div className="max-w-md text-center">
            {/* Decorative element */}
            <div className="mb-8">
              <svg className="w-16 h-16 mx-auto text-terracotta-400/50" viewBox="0 0 100 100" fill="none" aria-hidden="true">
                <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="0.5" />
                <circle cx="50" cy="50" r="35" stroke="currentColor" strokeWidth="0.5" />
                <path d="M50 20 L50 80 M20 50 L80 50" stroke="currentColor" strokeWidth="0.5" />
                <circle cx="50" cy="50" r="8" fill="currentColor" opacity="0.3" />
              </svg>
            </div>

            <Flourish aria-hidden="true" />

            <h1 className="font-serif text-4xl text-foreground mt-8 mb-4 tracking-tight">
              Creează momente
              <br />
              <span className="text-gradient-warm">de neuitat</span>
            </h1>

            <p className="text-muted-foreground leading-relaxed mb-8">
              Invitații digitale elegante pentru cele mai importante
              evenimente din viața ta. Nuntă, botez, aniversare -
              fiecare moment merită o invitație pe măsură.
            </p>

            <Flourish aria-hidden="true" />

            {/* Feature highlights */}
          </div>
        </div>

        {/* Bottom decorative border */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-terracotta-400/30 to-transparent" />
      </div>

      {/* Right side - Auth Form */}
      <div id="main" className="flex-1 flex flex-col items-center justify-center p-6 lg:p-12 bg-white relative">
        {/* Subtle background texture */}
        <div
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%' height='100%' filter='url(%23noise)'/%3E%3C/svg%3E")`,
          }}
        />

        {/* Mobile-only decorative top */}
        <div className="lg:hidden absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-terracotta-50/50 to-transparent" />

        <div className="w-full max-w-md relative z-10 animate-fade-in">
          <Outlet />
        </div>

        <p className="mt-8 text-xs text-stone-400 tracking-wide relative z-10">
          &copy; {new Date().getFullYear()} Invitații Online. Toate drepturile rezervate.
        </p>
      </div>
    </div>
  );
}
